import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import { selectFontsSlide, setSelectedFonts, toggleFontsSlide } from '../../store/slices/common';
import SlideOver from '../SlideOver';
import { createFonts, updateFonts } from '../../store/slices/api/inner/fontsSlice';

const FontsForm = ({
    defaultData,
    fetchData,
}) => {

    const FontsIsOpen = useSelector(selectFontsSlide);
    const dispatch = useDispatch();

    const defaultValues = {
        fontId: defaultData?.font_id ?? "",
        fontName: defaultData?.font_name ?? "",
        fontFamily: defaultData?.font_family ?? "",
    }

    const afterAPICall = (response) => {
        fetchData()
        dispatch(toggleFontsSlide())
        dispatch(setSelectedFonts(null))
    }

    const beforeAPICall = (data) => {
        return {
            success: true,
            refactoredData: {
                fontId: defaultData?.font_id ?? "",
                ...data,
            }
        }
    }
    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updateFonts : createFonts,
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            setValue('fontId', defaultData.font_id ?? "");
            setValue('fontName', defaultData.font_name ?? "");
            setValue('fontFamily', defaultData.font_family ?? "");
        } else {
            setValue('fontId', "");
            setValue('fontName', "");
            setValue('fontFamily', "");
        }
    }, [defaultData, setValue]);
    return (
        <SlideOver isOpen={FontsIsOpen} toggleOpen={toggleFontsSlide} panelName={defaultData ? "Update Fonts" : "Add Fonts"}>
            <form onSubmit={handleSubmit}>
                <Input
                    control={control}
                    name="fontName"
                    rules={{
                        required: "this field is required"
                    }}
                    label="Name"
                />
                <Input
                    control={control}
                    name="fontFamily"
                    rules={{
                        required: "this field is required"
                    }}
                    label="Font family"
                />
                <div className="flex justify-end my-6">
                    <Button isLoading={isLoading}>
                        {defaultData ? "Save changes" : "Submit"}
                    </Button>
                </div>
            </form>
        </SlideOver>
    )
}

export default FontsForm